"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _time = require('shared/services/time');







 const tzOptions = Object.entries(_time.timezoneNames)
  .map(([value, label]) => ({ value, label })); exports.tzOptions = tzOptions

 const daysList = Array(7).fill(0).map((_d, i) => i); exports.daysList = daysList
 const dayNames = exports.daysList.map(i => _moment2.default.call(void 0, ).day(i).format('dddd')); exports.dayNames = dayNames

const nullTeamHours = exports.daysList.map(i => ({
  dayOfWeek: i,
  availableFrom: '',
  availableUntil: '',
}))

 const makeDefaultValues = (
  defaultTimezone,
  defaultTeamHours,
) => {
  const teamHoursMap = defaultTeamHours
    .reduce((acc, th) => {
      if (th) {
        acc[th.DayOfWeek] = {
          dayOfWeek: th.DayOfWeek,
          availableFrom: th.AvailableFrom,
          availableUntil: th.AvailableUntil,
        }
      }
      return acc
    }, {} )

  const autoReplyTeamHours = nullTeamHours
    .map(th => teamHoursMap[th.dayOfWeek] || th)

  return {
    autoReplyTimezone: defaultTimezone || (_time.userTZ ),
    autoReplyTeamHours,
  }
}; exports.makeDefaultValues = makeDefaultValues

// The week as the hours list shows it, Monday first.
 const weekFromMonday = [1, 2, 3, 4, 5, 6, 0]; exports.weekFromMonday = weekFromMonday
 const shortDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; exports.shortDayNames = shortDayNames

// "8a", "9:30a", "6p"
const shortTime = (time) => {
  const t = _moment2.default.call(void 0, time, 'HH:mm:ss')
  return `${t.format(t.minutes() ? 'h:mm' : 'h')}${t.hours() < 12 ? 'a' : 'p'}`
}

 const dayHours = (d) =>
  d ? `${shortTime(d.AvailableFrom)}–${shortTime(d.AvailableUntil)}` : 'Closed'; exports.dayHours = dayHours

// The open days in one line, days in a row with the same hours joined:
// "Mon–Fri 8a–6p · Sat 9a–1p". The list is indexed by day, Sunday first.
 const hoursSummary = (list) => {
  const runs = []
  exports.weekFromMonday.forEach((day, i) => {
    const d = list[day]
    if (!d) return
    const hours = exports.dayHours.call(void 0, d)
    const last = runs[runs.length - 1]
    if (last && last.hours === hours && exports.weekFromMonday[i - 1] === last.to) last.to = day
    else runs.push({ from: day, to: day, hours })
  })
  return runs
    .map(r => `${exports.shortDayNames[r.from]}${r.from === r.to ? '' : `–${exports.shortDayNames[r.to]}`} ${r.hours}`)
    .join(' · ')
}; exports.hoursSummary = hoursSummary

// "ET" from "Eastern Time (ET)".
 const timezoneShort = (tz) =>
  (tz && _optionalChain([/\(([^)]+)\)$/, 'access', _ => _.exec, 'call', _2 => _2(_nullishCoalesce((_time.timezoneNames )[tz], () => ( ''))), 'optionalAccess', _3 => _3[1]])) || ''; exports.timezoneShort = timezoneShort
